import styled from "styled-components";

export const InviteLinkContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 32px;
`;

export const InviteLinkTitle = styled.p`
  color: #71207c;
  font-size: 18px;
  text-align: center;
  line-height: 28px;
  margin: 0px;
  padding: 0px;
  padding-bottom: 32px;
`;

export const InviteLinkTerm = styled.p`
  color: #71207c;
  font-size: 18px;
  text-align: center;
  line-height: 28px;
  margin: 0px;
  padding: 0px;
  padding-top: 80px;
  padding-bottom: 24px;
  font-weight: 600;
`;

export const InviteLinkTerms = styled.span`
  font-size: 14px;
  line-height: 28px;
  margin: 0px;
  padding: 0px;
  padding-bottom: 16px;
`;

export const CopyTitle = styled.p`
  color: #71207c;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
`;

export const CopyLink = styled.a`
  color: #000;
  font-size: 14px;
  text-decoration: underline;
  display: block;
  margin-bottom: 20px;
`;